// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ChannelRef, ChannelRefT, verifyChannelRef } from "./channel-ref";
import { LiftType } from "../archive/lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * GET /banks/light/:orgId — minimal bank info with nested channel→server.
 * Matches Go: models.BankLight { Name, Type, Channel{ID,Name,Server{ID,Name}}, ID }
 */
export class BankLight implements flatbuffers.IUnpackableObject<BankLightT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BankLight {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBankLight(bb: flatbuffers.ByteBuffer, obj?: BankLight): BankLight {
    return (obj || new BankLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBankLight(bb: flatbuffers.ByteBuffer, obj?: BankLight): BankLight {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BankLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  type(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  channel(obj?: ChannelRef): ChannelRef | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new ChannelRef()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startBankLight(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: LiftType) {
    builder.addFieldInt8(2, type, LiftType.ELEVATOR);
  }

  static addChannel(builder: flatbuffers.Builder, channelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, channelOffset, 0);
  }

  static endBankLight(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  unpack(): BankLightT {
    return new BankLightT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.type(),
      this.channel() !== null ? this.channel()!.unpack() : null,
    );
  }

  unpackTo(_o: BankLightT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.type = this.type();
    _o.channel = this.channel() !== null ? this.channel()!.unpack() : null;
  }

  unpackFields(...fields: string[]): BankLightT {
    const t = new BankLightT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("channel")) {
      t.channel = this.channel() !== null ? this.channel()!.unpack() : null;
    }
    return t;
  }
}

export class BankLightT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public type: LiftType = LiftType.ELEVATOR,
    public channel: ChannelRefT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const channel = this.channel !== null ? this.channel!.pack(builder) : 0;

    BankLight.startBankLight(builder);
    BankLight.addId(builder, id);
    BankLight.addName(builder, name);
    BankLight.addType(builder, this.type);
    BankLight.addChannel(builder, channel);

    return BankLight.endBankLight(builder);
  }

  clone(): BankLightT {
    const obj = new BankLightT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.type = this.type;
    obj.channel = this.channel !== null ? this.channel!.clone() : null;
    return obj;
  }

  equals(other: BankLightT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.type !== other.type) return false;
    if (this.channel !== null && other.channel !== null) {
      if (!this.channel!.equals(other.channel!)) return false;
    } else if (this.channel !== other.channel) return false;
    return true;
  }
}

export function verifyBankLight(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyChannelRef(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
